import ButtonTip from "../buttonTip";

export const ButtonEdit = ({ row, callback, afterCallback }) => {
  return (
    <ButtonTip
      className="btn-action rounded"
      type="button"
      size="sm"
      color="warning"
      id={"Tooltip-edit" + row._id}
      tooltipText="Editar"
      onClick={() => callback(row, afterCallback)}
    >
      <i className="fas fa-pencil-alt"></i>
    </ButtonTip>
  );
};

export const ButtonView = ({ row, callback, afterCallback }) => {
  return (
    <ButtonTip
      className="btn-action rounded"
      type="button"
      size="sm"
      color="info"
      id={"Tooltip-view" + row._id}
      tooltipText="Visualizar"
      onClick={() => callback(row, afterCallback)}
    >
      <i className="fas fa-eye"></i>
    </ButtonTip>
  );
};


export const ButtonToggle = ({ row, callback, afterCallback }) => {
  return (
    <ButtonTip
      className="btn-action rounded"
      size="sm"
      outline
      type="button"
      color={row.status ? "danger" : "info"}
      id={"Tooltip-status-edit" + row._id}
      tooltipText={row.status ? "Inativar" : "Reativar"}
      onClick={() => callback(row, afterCallback)}
    >
      <i className={row.status ? "fas fa-ban" : "fas fa-undo-alt"}></i>
    </ButtonTip>
  );
};

export const ButtonDelete = ({ row, callback, afterCallback }) => {
  return (
    <ButtonTip
      className="btn-action rounded"
      size="sm"
      type="button"
      color="danger"
      id={"Tooltip-delete" + row._id}
      tooltipText="Excluir"
      onClick={() => callback(row, afterCallback)}
    >
      <i className="fas fa-trash"></i>
    </ButtonTip>
  );
};
